import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import { Button, Modal, ButtonGroup } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Error from 'components/InPersonTraining/shared/Error';
import ReactHtml from 'components/shared/ReactHtml';

const DisconnectZoomConfirmationModal = ({
  closeModal,
  disconnectZoom,
  error,
}) => {
  return (
    <ModalContainer onEscape={closeModal}>
      <Modal shown className="LessonVersionModal-wrapper bg-gray-lightest">
        <Modal.Content className="d-f fd-c">
          <Text className="d-f my-16 pb-8 mb-16" variant={TEXT_VARIANTS.TITLE}>
            <ReactHtml component="span">
              {t(
                'in_person_training.events.disconnect_zoom_from_lessonly_confirmation_html',
              )}
            </ReactHtml>
          </Text>
          <Text className="d-f my-16 mb-8" variant={TEXT_VARIANTS.SUBHEADER}>
            {t('in_person_training.events.disconnecting_zoom_will')}
          </Text>
          <Text className="d-f my-16 mb-8" variant={TEXT_VARIANTS.SUBHEADER}>
            &bull;{' '}
            {t(
              'in_person_training.events.disable_creation_of_zoom_meetings_in_lessonly',
            )}
          </Text>
          <Text className="d-f my-16" variant={TEXT_VARIANTS.SUBHEADER}>
            &bull;{' '}
            <ReactHtml className="pl-4" component="span">
              {t(
                'in_person_training.events.remove_existing_zoom_meetings_from_events_html',
              )}
            </ReactHtml>
          </Text>
          {error && <Error errorMessage={t('common.oops_notify_error')} />}
        </Modal.Content>

        <ButtonGroup alignEnd className="pb-32 pr-32">
          <Button onClick={closeModal}>{t('common.close')}</Button>
          <Button primary onClick={disconnectZoom}>
            {t('common.disconnect')}
          </Button>
        </ButtonGroup>
      </Modal>
    </ModalContainer>
  );
};

export default DisconnectZoomConfirmationModal;
